import React, { useEffect, useMemo, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { extractTableHeaders } from 'utils/hooks/reportTableUtils';
import { DataTypeB0202, BProps } from 'store/ducks/Reportings/types';
import { columnsB0202 } from 'constants/reportColumns';

const B0202: React.FC<BProps> = ({ entityName }) => {
  const { date, is_displayed, headers } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<DataTypeB0202[]>([]);
  const memoizedColumns = useMemo(() => columnsB0202, [columnsB0202]);
  const dispatch = useDispatch();
  const fetchData = async () => {
    dispatch(set_isDisplayed(false));
    const entityIds: string[] = entityName
      ? entityName.split(',').map((id) => id.trim())
      : [];

    const params = {
      entityId: entityIds,
      date,
    };
    try {
      const fetchedData = await reportingOp.fetchRT0202(params);

      if (fetchedData && fetchedData.entities) {
        const date = fetchedData.date;
        const allEntities = Object.values(fetchedData.entities).flat();

        const formattedData = allEntities.map(
          (dataItem: any, index: number) => ({
            key: index,
            date,
            entity_name: dataItem.entity_name,
            contractual_arangement_ref_num:
              dataItem.arrangement_reference_number,
            country_of_ict_services: dataItem.country_of_ict_services?.slice(
              0,
              2,
            ),
            data_location_processing: dataItem.data_location_processing,
            data_location_storage: dataItem.data_location_storage,
            data_sensitiveness: dataItem.data_sensitiveness,
            end_date: dataItem.end_date,
            entity_notice_period: dataItem.entity_notice_period,
            function_identifier: dataItem.function_identifier,
            governing_law_country: dataItem.governing_law_country?.slice(0, 2),
            ict_service_provider_code: dataItem.ict_service_provider_code,
            lei_of_the_entity_using_ict_service:
              dataItem.lei_entity_using_ict_service,
            level_of_reliance: dataItem.level_of_reliance,
            provider_notice_period: dataItem.provider_notice_period,
            start_date: dataItem.start_date,
            storage_of_data: dataItem.storage_of_data,
            termination_reason: dataItem.termination_reason,
            type_of_ict_service_provider_code: dataItem.provider_code_type,
            type_of_ict_services: dataItem.ict_service_type,
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (entityName) {
      fetchData();
    }
  }, [is_displayed, entityName]);

  useEffect(() => {
    extractTableHeaders(memoizedColumns, dispatch);
  }, []);

  return (
    <>
      <Table
        columns={columnsB0202}
        dataSource={data}
        scroll={{ x: 1000, y: 430 }}
      />
    </>
  );
};

export default B0202;
